var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounShoppingBag159084(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75,30C75,13.4,63.8,0,50,0S25,13.4,25,30H13l6,70h62l6-70H75z M50,4c11.6,0,21,11.7,21,26H29C29,15.7,38.4,4,50,4z M65,50  c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S65,47.2,65,50z M45,50c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S45,47.2,45,50z M50,85.1  c-12.4,0-22.5-10.1-22.5-22.5h5c0,9.6,7.9,17.5,17.5,17.5s17.5-7.8,17.5-17.5h5C72.5,75,62.4,85.1,50,85.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounShoppingBag159084);
export default __webpack_public_path__ + "static/media/noun_Shopping Bag_159084.28d2a2be.svg";
export { ForwardRef as ReactComponent };